<div class="modal">
  <div class="modal-ctn">

    <div class="mission">
      <a>MISSION</a>
      <a>{{ 'MISSIONS.FLOWRATE' | translate }}: {{ mission.DMDSExpectedMinFlowrate | number : '1.0-2' }} - {{ mission.DMDSExpectedMaxFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</a>
      <a>{{ 'MISSIONS.INJECTION_PRESSURE' | translate }}: {{ mission.unitDMDSInjectionPointPressure | number : '1.0-2' }} {{ mission.pressureUom }}</a>
    </div>

    <div class="options">
      <input type="text" (keyup)="filterSkids($event)">
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <div class="skids">
      @for (skid of displayedSkids; track skid) {
        <div [ngClass]="isNoDigital(skid) ? 'skid no-digital' : 'skid'">
          <div class="logo">
            <div class="equipments">
              @if (skid.hasPump) {
                <img src="assets/images/pump.png"/>
              }
              @if (skid.hasFlowmeter) {
                <img src="assets/images/flowmeter.png"/>
              }
              @if (skid.hasGateway) {
                <img src="assets/images/gateway.jpeg"/>
              }
            </div>
            <a>{{ skid.skidName }}</a>
          </div>
          <div class="info">
            @if (!isNoDigital(skid)) {
              @if (skid.hasPump) {
                <a>{{ 'SKID.FLOWRATE' | translate }}: {{ skid.pumpFlowrateRange }} {{ mission.volumeFlowrateUom }}</a>
                <a>{{ 'SKID.MAX_PRESSURE' | translate }}: {{ skid.pumpMaxPressure }} {{ mission.pressureUom }}</a>
                <a>{{ 'SKID.PUMP_MODELSUPPLIER' | translate }}: {{ skid.pumpmodelSupplier }}</a>
                <a>{{ 'SKID.PUMP_TYPE' | translate }}: {{ skid.pumpmodelName }}</a>
              }
              @if (skid.hasGateway) {
                <a>{{ 'MISSION_SKID.GATEWAY' | translate }}: {{ skid.gatewayName }}</a>
              }
              @if (skid.hasFlowmeter) {
                <a>{{ 'MISSION_SKID.FLOWMETER' | translate }}: {{ skid.flowmeterName }}</a>
              }
            }
          </div>
          <div class="add" (click)="addSkid(skid)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>